module.exports = __webpack_public_path__ + "static/media/HarveyWaroonaReporter-devicecomp-min.315c2504.webp";